import TextControl from "../../controls/text-control/text-control";
import { TextControlProps } from "types";

type EmailControlProps = Omit<TextControlProps, "pattern" | "type">;

const EmailControl = (props: EmailControlProps) => {
	const extendedProps = {
		...props,
		pattern: {
			value: /^(([0-9A-ZñÑ&/$\-._]+)@\w+([-.]\w+)*\.\w+([-.]\w+)*)$/i,
			message: "Debes indicar una dirección de correo electrónico válida"
		}
	};

	return (
		<TextControl {...extendedProps} type="email" />
	);
};

export default EmailControl;